export const WarningIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='8' fill='#F97316' />
    <path
      d='M8.70898 5.66016V12H7.29102V5.66016H8.70898ZM7.19727 3.99609C7.19727 3.78125 7.26758 3.60352 7.4082 3.46289C7.55273 3.31836 7.75195 3.24609 8.00586 3.24609C8.25586 3.24609 8.45312 3.31836 8.59766 3.46289C8.74219 3.60352 8.81445 3.78125 8.81445 3.99609C8.81445 4.20703 8.74219 4.38281 8.59766 4.52344C8.45312 4.66406 8.25586 4.73438 8.00586 4.73438C7.75195 4.73438 7.55273 4.66406 7.4082 4.52344C7.26758 4.38281 7.19727 4.20703 7.19727 3.99609Z'
      fill='white'
    />
  </svg>
);

export const ErrorIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='8' fill='#EF4444' />
    <path
      d='M8.76758 3.46875L8.62695 9.48633H7.41992L7.27344 3.46875H8.76758ZM7.23242 11.332C7.23242 11.1172 7.30273 10.9375 7.44336 10.793C7.58789 10.6445 7.78711 10.5703 8.04102 10.5703C8.29102 10.5703 8.48828 10.6445 8.63281 10.793C8.77734 10.9375 8.84961 11.1172 8.84961 11.332C8.84961 11.5391 8.77734 11.7168 8.63281 11.8652C8.48828 12.0098 8.29102 12.082 8.04102 12.082C7.78711 12.082 7.58789 12.0098 7.44336 11.8652C7.30273 11.7168 7.23242 11.5391 7.23242 11.332Z'
      fill='white'
    />
  </svg>
);

export const SuccessIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='8' fill='#16A34A' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.3827 5.3019C12.7682 5.69734 12.7602 6.33045 12.3648 6.716L6.98989 11.9565L4.30353 9.34916C3.90722 8.96451 3.89777 8.33141 4.28242 7.9351C4.66707 7.53879 5.30017 7.52935 5.69648 7.914L6.98672 9.1663L10.9686 5.284C11.364 4.89845 11.9971 4.90646 12.3827 5.3019Z'
      fill='white'
    />
  </svg>
);

export const DefaultIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='16' height='16' rx='8' fill='inherit' />
    <path
      d='M8.70898 5.66016V12H7.29102V5.66016H8.70898ZM7.19727 3.99609C7.19727 3.78125 7.26758 3.60352 7.4082 3.46289C7.55273 3.31836 7.75195 3.24609 8.00586 3.24609C8.25586 3.24609 8.45312 3.31836 8.59766 3.46289C8.74219 3.60352 8.81445 3.78125 8.81445 3.99609C8.81445 4.20703 8.74219 4.38281 8.59766 4.52344C8.45312 4.66406 8.25586 4.73438 8.00586 4.73438C7.75195 4.73438 7.55273 4.66406 7.4082 4.52344C7.26758 4.38281 7.19727 4.20703 7.19727 3.99609Z'
      fill='white'
    />
  </svg>
);
